import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'smartflip-account-deletion-confirmation-modal',
  templateUrl: './account-deletion-confirmation-modal.component.html',
  styleUrls: ['./account-deletion-confirmation-modal.component.scss'],
  imports: [IonicModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountDeletionConfirmationModalComponent {
  constructor(private modalController: ModalController) {}

  cancel() {
    this.modalController.dismiss(false);
  }

  confirm() {
    this.modalController.dismiss(true);
  }
}
